import { render } from "./DatasetSegmentsForm.vue?vue&type=template&id=35656fb8"
import script from "./DatasetSegmentsForm.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__